<!-- 타겟그룹 간편처방 필터 -->
<template>
  <div>
    <div v-if="isDrugLanding">
      <!-- 포함 조건 영역 -->
      <b-row class="mt-1">
        <b-col cols="12">
          <div class="condition-block include-block">
            <div class="d-flex align-items-center mb-1">
              <b-badge variant="light-primary">
                + 포함 조건
              </b-badge>
              <span class="ml-1 text-muted">선택한 간편처방을 등록한 사용자를 포함합니다.</span>
            </div>

            <!-- 교차 조건 -->
            <label class="d-block">교차 조건</label>
            <b-form-radio-group
              v-model="isAndCrossInclude"
              :disabled="isReadonly"
            >
              <b-form-radio
                class="custom-control-primary"
                :value="false"
              >
                OR
              </b-form-radio>
              <b-form-radio
                class="custom-control-primary"
                :value="true"
              >
                AND
              </b-form-radio>
            </b-form-radio-group>

            <label class="d-block mt-1">활동</label>
            <b-button
              :disabled="isReadonly"
              variant="outline-primary"
              class="mt-0"
              @click.prevent="showDrugLandingSelectPopup(false)"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              <span>간편처방등록 추가</span>
            </b-button>
            <b-table
              :items="includeFilters"
              :fields="selectedTableColumns"
              sort-by="filterId"
              :sort-desc="true"
              :hover="false"
              bordered
              empty-text="추가된 간편처방등록이 없습니다."
              show-empty
              class="mt-1"
            >
              <template #cell(isAfterConsultPopup)="data">
                <div
                  class="text-nowrap"
                  style="text-align: center;"
                >
                  {{ data.value === null || data.value === undefined ? '-' : (data.value ? 'O' : 'X') }}
                </div>
              </template>
              <template #cell(isDelete)="data">
                <b-button
                  variant="link"
                  size="sm"
                  class="btn-hover-trash"
                  :disabled="isReadonly"
                  @click.prevent="removeRow(data.item)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    size="16"
                    class="text-danger"
                  />
                </b-button>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>

      <!-- 제외 조건 영역 -->
      <b-row class="mt-1">
        <b-col cols="12">
          <div class="condition-block exclude-block">
            <div class="d-flex align-items-center mb-1">
              <b-badge variant="light-danger">
                - 제외 조건
              </b-badge>
              <span class="ml-1 text-muted">선택한 간편처방을 등록한 사용자를 제외합니다.</span>
            </div>

            <!-- 교차 조건 -->
            <label class="d-block">교차 조건</label>
            <b-form-radio-group
              v-model="isAndCrossExclude"
              :disabled="isReadonly"
            >
              <b-form-radio
                class="custom-control-primary"
                :value="false"
              >
                OR
              </b-form-radio>
              <b-form-radio
                class="custom-control-primary"
                :value="true"
              >
                AND
              </b-form-radio>
            </b-form-radio-group>

            <label class="d-block mt-1">활동</label>
            <b-button
              :disabled="isReadonly"
              variant="outline-primary"
              class="mt-0"
              @click.prevent="showDrugLandingSelectPopup(true)"
            >
              <feather-icon
                icon="SearchIcon"
                class="mr-50"
              />
              <span>간편처방등록 추가</span>
            </b-button>
            <b-table
              :items="excludeFilters"
              :fields="selectedTableColumns"
              sort-by="filterId"
              :sort-desc="true"
              :hover="false"
              bordered
              empty-text="추가된 간편처방등록이 없습니다."
              show-empty
              class="mt-1"
            >
              <template #cell(isAfterConsultPopup)="data">
                <div
                  class="text-nowrap"
                  style="text-align: center;"
                >
                  {{ data.value === null || data.value === undefined ? '-' : (data.value ? 'O' : 'X') }}
                </div>
              </template>
              <template #cell(isDelete)="data">
                <b-button
                  variant="link"
                  size="sm"
                  class="btn-hover-trash"
                  :disabled="isReadonly"
                  @click.prevent="removeRow(data.item)"
                >
                  <feather-icon
                    icon="Trash2Icon"
                    size="16"
                    class="text-danger"
                  />
                </b-button>
              </template>
            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>

    <!-- 간편처방등록 선택 모달 -->
    <drug-landing-select
      v-if="filterType"
      :show-drug-landing-select="showDrugLandingSelect"
      :is-exclude="isExcludeDrugLandingSelect"
      :filter-type="filterType"
      :selected-value="currentGroupFilters.map(i => i.filterId)"
      @close="drugLandingSelect.close"
    />
  </div>
</template>

<script>
import {
  ref, computed, set, watch,
} from '@vue/composition-api'
import { BBadge } from 'bootstrap-vue'
import DrugLandingSelect from '../DrugLandingSelect.vue'

export default {
  components: {
    DrugLandingSelect,
    BBadge,
  },

  props: {
    targetGroupData: {
      type: Object,
      required: true,
    },
    codes: {
      type: Object,
      required: true,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    filterType: {
      type: Number,
      required: false,
      default: null,
    },
    drugLandingToggleState: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const isDrugLanding = computed(() => props.drugLandingToggleState)

    // 포함/제외 목록
    const includeFilters = computed(() => props.targetGroupData.targetGroupFilters.filter(x => x.filterType === props.filterType && !x.isExclude))
    const excludeFilters = computed(() => props.targetGroupData.targetGroupFilters.filter(x => x.filterType === props.filterType && x.isExclude))

    const isAndCrossInclude = ref(true)
    const isAndCrossExclude = ref(true)

    // 로드 시 첫 필터의 isAndCross 값으로 동기화, 비어있으면 Default AND(true)로 초기화
    watch(includeFilters, newFilters => {
      if (newFilters && newFilters.length > 0) {
        isAndCrossInclude.value = newFilters[0].isAndCross ?? true
      } else {
        isAndCrossInclude.value = true
      }
    }, { immediate: true, deep: true })
    watch(excludeFilters, newFilters => {
      if (newFilters && newFilters.length > 0) {
        isAndCrossExclude.value = newFilters[0].isAndCross ?? true
      } else {
        isAndCrossExclude.value = true
      }
    }, { immediate: true, deep: true })

    // 교차조건 변경 시 해당 그룹 전체 필터에 반영
    watch(isAndCrossInclude, newValue => {
      includeFilters.value.forEach(filter => {
        set(filter, 'isAndCross', newValue)
      })
    })
    watch(isAndCrossExclude, newValue => {
      excludeFilters.value.forEach(filter => {
        set(filter, 'isAndCross', newValue)
      })
    })

    const selectedTableColumns = [
      {
        key: 'filterId', label: 'ID', sortable: false, thStyle: { width: '10%' },
      },
      {
        key: 'clientName', label: '제약사', sortable: false, thStyle: { width: '15%' },
      },
      { key: 'title', label: '제목', sortable: false },
      {
        key: 'isAfterConsultPopup', label: '진료후팝업', sortable: false, thStyle: { width: '10%' },
      },
      {
        key: 'period', label: '게시 기간', sortable: false, thStyle: { width: '25%' },
      },
      {
        key: 'isDelete', label: '', sortable: false, thStyle: { width: '50px' }, tdClass: 'text-center p-0',
      },
    ]

    // 간편처방등록 선택 모달
    const showDrugLandingSelect = ref(false)
    const isExcludeDrugLandingSelect = ref(false)
    const currentGroupFilters = computed(() => (isExcludeDrugLandingSelect.value ? excludeFilters.value : includeFilters.value))

    const showDrugLandingSelectPopup = isExclude => {
      isExcludeDrugLandingSelect.value = isExclude
      showDrugLandingSelect.value = true
    }

    const drugLandingSelect = {
      close: rs => {
        showDrugLandingSelect.value = false
        if (!rs || rs.length === 0) return

        const existing = currentGroupFilters.value
        const groupIsAndCross = isExcludeDrugLandingSelect.value ? isAndCrossExclude.value : isAndCrossInclude.value

        // 신규 선택 항목만 추가
        const newFilters = []
        rs.forEach(item => {
          const alreadyExists = existing.some(x => x.filterId === item.filterId && x.isExclude === item.isExclude)
          if (!alreadyExists) {
            newFilters.push({
              ...item,
              filterType: props.filterType,
              isAndCross: groupIsAndCross,
            })
          }
        })

        props.targetGroupData.targetGroupFilters.push(...newFilters)
      },
    }

    const removeRow = item => {
      const idx = props.targetGroupData.targetGroupFilters.findIndex(x => x.filterType === props.filterType && x.filterId === item.filterId && x.isExclude === item.isExclude)
      if (idx !== -1) {
        props.targetGroupData.targetGroupFilters.splice(idx, 1)
      }
    }

    return {
      isDrugLanding,
      includeFilters,
      excludeFilters,
      isAndCrossInclude,
      isAndCrossExclude,
      selectedTableColumns,
      showDrugLandingSelect,
      isExcludeDrugLandingSelect,
      currentGroupFilters,
      showDrugLandingSelectPopup,
      drugLandingSelect,
      removeRow,
    }
  },
}
</script>

<style scoped>
.condition-block {
  border: 1px solid #d8d6de;
  border-radius: 0.5rem;
  padding: 1rem;
}
.include-block {
  border-color: #7367f0;
}
.exclude-block {
  border-color: #ea5455;
}
.btn-hover-trash:hover {
  background: linear-gradient(to right, #ffe5e5, #ffcccc);
  border-radius: 4px;
}
</style>
